"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Form = require("../../browser/Form");
var _excluded = ["id", "input", "element", "type", "required", "children", "labelId", "hideErrorLabel", "hideLabel", "meta", "errorMessage", "displayValue", "styleInput", "styleInputError", "styleContainer", "styleWrapper"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null == arguments[r] ? {} : arguments[r]; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var FormField = function FormField(props) {
  var id = props.id,
    input = props.input,
    element = props.element,
    type = props.type,
    required = props.required,
    children = props.children,
    labelId = props.labelId,
    hideErrorLabel = props.hideErrorLabel,
    hideLabel = props.hideLabel,
    meta = props.meta,
    errorMessage = props.errorMessage,
    displayValue = props.displayValue,
    styleInput = props.styleInput,
    styleInputError = props.styleInputError,
    styleContainer = props.styleContainer,
    styleWrapper = props.styleWrapper,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var active = meta.active,
    touched = meta.touched,
    error = meta.error,
    submitError = meta.submitError;
  var _useIntl = (0, _reactIntl.useIntl)(),
    formatMessage = _useIntl.formatMessage;
  var placeholder = labelId ? formatMessage({
    id: labelId
  }) : '';
  if (displayValue) return _react["default"].createElement(_Form.FieldWrapper, null, _react["default"].createElement(_Form.Label, {
    htmlFor: id
  }, labelId && _react["default"].createElement(_reactIntl.FormattedMessage, {
    id: labelId
  })), _react["default"].createElement(_Form.FormInput, null, _react["default"].createElement(_Form.Display, null, displayValue)));
  var Element = {
    input: _Form.Input,
    select: _Form.Select
  }[element];
  var styleError = (error || submitError) && touched ? styleInputError : {};
  return _react["default"].createElement(_Form.FieldWrapper, {
    style: styleWrapper
  }, !hideLabel && _react["default"].createElement(_Form.Label, {
    htmlFor: id
  }, labelId && _react["default"].createElement(_reactIntl.FormattedMessage, {
    id: labelId
  }), required && _react["default"].createElement(_Form.Asterisk, null, "*")), _react["default"].createElement(_Form.FormInput, {
    style: styleContainer
  }, _react["default"].createElement(Element, (0, _extends2["default"])({}, input, rest, {
    id: id,
    type: type,
    placeholder: element === 'input' ? placeholder : undefined,
    style: _objectSpread(_objectSpread({}, styleInput), styleError)
  }), children), error && !hideErrorLabel && touched && _react["default"].createElement(_Form.FormError, null, _react["default"].createElement(_reactIntl.FormattedMessage, {
    id: error.message,
    values: {
      value: error.value
    }
  })), submitError && !hideErrorLabel && touched && _react["default"].createElement(_Form.FormError, null, _react["default"].createElement(_reactIntl.FormattedMessage, {
    id: submitError
  })), errorMessage && !error && !hideErrorLabel && !touched && !active && _react["default"].createElement(_Form.FormError, null, errorMessage)));
};
FormField.defaultProps = {
  element: 'input',
  hideErrorLabel: false,
  styleInput: {},
  styleInputError: {},
  styleContainer: {},
  styleWrapper: {}
};
var _default = exports["default"] = FormField;